const UPLOADCARE_MAX_DIMENSION_SUPPORT = 3e3;
const getMaxAvailableDimension = (currentDimension) => {
  return currentDimension > UPLOADCARE_MAX_DIMENSION_SUPPORT ? UPLOADCARE_MAX_DIMENSION_SUPPORT : currentDimension;
};
class StandartAlignment {
  constructor(value) {
    this.toValue = () => this.value;
    this.value = value;
  }
}
class OffsetAlignment {
  constructor(width, height) {
    this.toValue = () => `${this.width},${this.height}`;
    this.width = width;
    this.height = height;
  }
}
class SmartResize {
  constructor(width, height) {
    this.toValue = () => `-/smart_resize/${this.width}x${this.height}/`;
    this.width = getMaxAvailableDimension(width);
    this.height = getMaxAvailableDimension(height);
  }
}
class Resize {
  constructor(width, height) {
    this.toValue = () => `-/resize/${this.width}x${this.height || ""}/`;
    this.width = getMaxAvailableDimension(width);
    this.height = height && getMaxAvailableDimension(height);
  }
}
class Preview {
  constructor(width, height) {
    this.toValue = () => `-/preview/${this.width}x${this.height}/`;
    this.width = width;
    this.height = height;
  }
}
class Crop {
  constructor(width, height, alignment) {
    this.toValue = () => `-/crop/${this.width}x${this.height}` + (this.alignment ? `/${this.alignment.toValue()}/` : "/");
    this.width = getMaxAvailableDimension(width);
    this.height = getMaxAvailableDimension(height);
    this.alignment = alignment;
  }
}
class Overlay {
  constructor(imageUrl, width, height, alignment) {
    this.toValue = () => `-/overlay/${this.image}/${this.width}x${this.height}` + (this.alignment ? `/${this.alignment.toValue()}/` : "/");
    const urlParts = imageUrl.split("/");
    this.image = urlParts[urlParts.length - 2];
    this.width = getMaxAvailableDimension(width);
    this.height = getMaxAvailableDimension(height);
    this.alignment = alignment;
  }
}
class Stretch {
  constructor(value) {
    this.toValue = () => `-/stretch/${this.value}/`;
    this.value = value;
  }
}
class ScaleCrop {
  constructor(width, height, type) {
    this.toValue = () => `-/scale_crop/${this.width}x${this.height}/` + (this.type ? `${this.type}/` : "");
    this.width = getMaxAvailableDimension(width);
    this.height = getMaxAvailableDimension(height);
    this.type = type;
  }
}
const getUploadCareUrl = ({
  src,
  format = "webp",
  filter,
  invert,
  quality,
  transformations = []
}) => {
  const params = [
    `-/format/${format}/`,
    filter && `-/filter/${filter}/`,
    invert && "-/invert/",
    quality && `-/quality/${quality}/`,
    ...transformations.map((transformation) => transformation.toValue())
  ].filter(Boolean);
  const divider = src.endsWith("/") ? "" : "/";
  return `${src}${divider}${params.join("")}`;
};
const getImageResizeWidth = (ref, fallbackWidth, percentage = 60) => {
  var _a;
  if ((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.offsetWidth) {
    const width = ref.current.offsetWidth;
    const percentageAsWidth = width * (percentage / 100);
    return Math.round(width + percentageAsWidth);
  }
  return fallbackWidth;
};
export {
  Crop,
  OffsetAlignment,
  Overlay,
  Preview,
  Resize,
  ScaleCrop,
  SmartResize,
  StandartAlignment,
  Stretch,
  getImageResizeWidth,
  getUploadCareUrl
};
